<template>
  <div>
    <b-message v-if="edit" class="mt-3" type="is-primary">
      {{ $t("copyLoadInExplained") }}
    </b-message>
    <form ref="form">
      <div v-for="(person, key) in persons" :key="person._sortId">
        <b-field class="my-3">
          <b-input
            v-model="person.email"
            class="control"
            type="email"
            :readonly="edit ? false : true"
            expanded
            :placeholder="$t('email')"
          />

          <b-input v-model="person.personalToken" class="control" />
          <p v-if="edit" class="control">
            <b-button
              type="is-danger"
              :loading="isLoading"
              :disabled="isDisabled"
              icon-left="delete"
              @click="removePerson(key)"
            />
          </p>
        </b-field>
      </div>
    </form>
    <b-button v-if="edit" type="is-success" icon-left="plus" @click="addPerson" />
    <b-upload v-if="edit" v-model="file" class="has-text-right is-pulled-right ml-2" @input="input">
      <a class="has-text-right is-pulled-right button">
        <b-icon icon="upload" />
        <span>{{ $t("fileUpload") }}</span>
      </a>
    </b-upload>

    <b-button
      v-if="edit"
      class="has-text-right is-pulled-right pr-2"
      type="is-primary"
      :loading="isLoading"
      :disabled="isDisabled || !isValid"
      @click="csvExport"
    >
      <b-icon icon="download" />
      <span>{{ $t("csvExport") }}</span>
    </b-button>
  </div>
</template>

<script>
import { v4 } from "uuid";
const Papa = require("papaparse");
const createCsvStringifier = require("csv-writer").createObjectCsvStringifier;

const placeholders = {
  n: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  s: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ],
  l: [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ],
  L: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ],
};

const generateString = function (schema) {
  return schema
    .split("")
    .map((c) => {
      if (placeholders[c]) {
        return placeholders[c][Math.floor(Math.random() * placeholders[c].length)];
      }
      return c;
    })
    .join("");
};

export default {
  name: "Personalization",
  components: {},
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file: null,
      isValid: false,
      isDisabled: false,
      isLoading: false,
    };
  },
  computed: {
    persons: {
      get() {
        return this.$store.state.survey.persons;
      },
      set(value) {
        this.$store.commit("SET_SURVEY_FIELD", ["persons", value]);
      },
    },
  },
  watch: {
    persons: {
      deep: true,
      handler() {
        this.persons.forEach((input, index) => {
          let splitted = input.email.split(/,|;/g);
          if (splitted.length > 1) {
            for (let k = 1; k < splitted.length; k++) {
              this.addPerson(splitted[k].trim());
            }
            this.$set(this.persons[index], "email", splitted[0].trim());
          }
        });
        this.isValid = this.$refs.form.checkValidity();
      },
    },
  },
  mounted() {
    if (Object.keys(this.persons).length == 0 || !this.persons) {
      this.addPerson();
    }
  },
  methods: {
    addPerson(email) {
      let emailString = typeof email == "string" ? email : "";
      this.persons.push({
        _sortId: v4(),
        email: emailString,
        personalToken: generateString("LLnnnn"),
      });
    },
    removePerson(key) {
      this.$delete(this.persons, key);
    },
    input() {
      if (this.file) {
        if (this.file.type == "text/csv") {
          let self = this;
          try {
            Papa.parse(this.file, {
              complete: function (results) {
                for (let row of results.data) {
                  for (let value of row) {
                    const re =
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(String(value).toLowerCase())) {
                      self.addPerson(value);
                    }
                  }
                }
              },
            });
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$t("CSVRead"),
            });
          } catch (error) {
            this.$buefy.toast.open({
              message: this.$t("CSVCouldNotBeRead"),
              type: "is-danger",
            });
          }
        } else {
          this.$buefy.toast.open({
            message: this.$t("plsUploadCSV"),
            type: "is-danger",
          });
        }
      }
    },
    csvExport() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        const csvStringifier = createCsvStringifier({
          header: [
            { id: "title", title: "Titel" },
            { id: "surveyCode", title: "Umfragecode" },
            { id: "email", title: "E-Mail" },
            { id: "personalToken", title: "Benutzercode" },
          ],
          fieldDelimiter: ";",
        });
        let csvObj = Object.assign(this.persons, {
          title: this.$store.state.survey.title,
        });
        let csvData = csvStringifier.getHeaderString() + csvStringifier.stringifyRecords(csvObj);

        var blob = new Blob([csvData], { type: "text/csv" });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, `export__${this.$store.state.survey.title}_invite_codes.csv`);
        } else {
          var elem = window.document.createElement("a");
          elem.href = window.URL.createObjectURL(blob);
          elem.download = `export__${this.$store.state.survey.title}_invite_codes.csv`;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style></style>
